import { Box, FormLabel, HTMLWrapper } from "@/storybook-components";
import type { Question } from "@/types";

interface SectionQuestionProps {
  question: Question;
}

const SectionQuestion = ({ question }: SectionQuestionProps): JSX.Element => {
  return (
    <Box my={4}>
      <FormLabel>
        <HTMLWrapper html={question.question} />
      </FormLabel>
      {question.descriptor && <HTMLWrapper html={question.descriptor} />}
    </Box>
  );
};

export default SectionQuestion;
